export default __webpack_public_path__ + "static/IBMPlexSans-Thin-7ca154e5a724d5a17af3838a227635b7.woff";